import * as SolidIcons from "@heroicons/react/24/solid"
import * as OutlineIcons from "@heroicons/react/24/outline"

function Icon({ icon, variant = "outline", className = "", ...props }) {
  const icons = variant === "solid" ? SolidIcons : OutlineIcons
  const iconFullName = `${icon}Icon`
  const IconComponent = icons[iconFullName]

  if (!IconComponent) {
    return null
  }

  return <IconComponent className={className} {...props} />
}

export { Icon }
